const getCardPreferanceReducer = (state = { cardPreferanceState: {} }, action) => {
          switch (action.type) {
              case "GET_CARDPREFERANCE":
                  return {
                    cardPreferanceState: action.cardPreferanceState,
                  }
      
              default:
                  return state;
          }
      }
      
      export default getCardPreferanceReducer;


// WEBPACK FOOTER //
// ./src/reducer/getcardpreferanceReducer.jsx